module.exports = __webpack_public_path__ + "static/img/NSW-27.46d3b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-27.jpg
// module id = rL4U
// module chunks = 0